/* @flow */
import { capitalize } from 'lodash';
import * as React from 'react';

import AvatarWithText from 'components/AvatarWithText';
import UserAvatar from 'users/components/UserAvatar';
import { formatNameForActionsMenuButton } from 'user/components/UserActionsMenuButton';

import type { UnsafePartialUser } from 'users/components/UserAvatar';

type Props = {
  avatar?: React.Element,
  subtext?: string,
  user: $Shape<
    UnsafePartialUser & {
      name?: string,
      first_name?: string,
      last_name?: string,
      firstName?: string,
      lastName?: string,
      role: string,
    }
  >,
};

export default function UsersAvatarWithText({ avatar, subtext, user, ...others }: Props) {
  return (
    <AvatarWithText
      {...others}
      title={formatNameForActionsMenuButton(user)}
      avatar={avatar || <UserAvatar user={user} />}
      subtext={subtext || capitalize(user.role)}
    />
  );
}
